/**
 * Status / type / method / currency → i18n key + AntD Tag colour.
 *
 * The ONLY place enum wire-values map to a renderable label + colour. UI
 * components (StatusChip, type tabs, method cells) resolve through these maps —
 * never inline a Cyrillic/Latin literal. Labels are i18n keys under the
 * `accounting` namespace; colours are AntD `Tag`/`Badge` colour strings
 * (preset names so they track the AntD theme, not raw hex).
 */

import type {
  Currency,
  InvoiceStatus,
  InvoiceType,
  PaymentMethod,
  TxnStatus,
  TxnType,
} from '../api/contracts'

export interface StatusMeta {
  /** i18n key under the `accounting` namespace. */
  labelKey: string
  /** AntD Tag/Badge preset colour name. */
  color: string
}

// yangi | to'lovda | tasdiqlandi
export const TXN_STATUS_META: Record<TxnStatus, StatusMeta> = {
  UNPAID: { labelKey: 'txn_status.UNPAID', color: 'warning' },
  INVOICED: { labelKey: 'txn_status.INVOICED', color: 'processing' },
  SETTLED: { labelKey: 'txn_status.SETTLED', color: 'success' },
}

export const INVOICE_STATUS_META: Record<InvoiceStatus, StatusMeta> = {
  PENDING: { labelKey: 'invoice_status.PENDING', color: 'warning' },
  PAID: { labelKey: 'invoice_status.PAID', color: 'success' },
}

// kirim | chiqim
export const TXN_TYPE_META: Record<TxnType, StatusMeta> = {
  INCOME: { labelKey: 'txn_type.INCOME', color: 'success' },
  EXPENSE: { labelKey: 'txn_type.EXPENSE', color: 'error' },
}

export const INVOICE_TYPE_META: Record<InvoiceType, StatusMeta> = {
  INCOME: { labelKey: 'invoice_type.INCOME', color: 'success' },
  EXPENSE: { labelKey: 'invoice_type.EXPENSE', color: 'error' },
}

// naqd | perevod | plastik | valyuta — label only (no semantic colour)
export const PAYMENT_METHOD_META: Record<PaymentMethod, { labelKey: string }> = {
  CASH: { labelKey: 'payment_method.CASH' },
  TRANSFER: { labelKey: 'payment_method.TRANSFER' },
  CARD: { labelKey: 'payment_method.CARD' },
  FX: { labelKey: 'payment_method.FX' },
}

export const CURRENCY_LABEL_KEY: Record<Currency, string> = {
  UZS: 'currency.UZS',
  USD: 'currency.USD',
}
